import "./i18n";
import { RouteToRender } from "./routes";
import routes from "./routes";

function App() {
  return <RouteToRender route={routes} />;
}

export default App;
